import type { ClientEvent } from '@/types/events';
import { appStore } from '@/data/storage/app/adapter';

export async function addClientEventBase(
  coachId: string | null | undefined,
  evt: Omit<ClientEvent, 'id' | 'createdAt' | 'coachId'>,
) {
  const rows = await appStore.getClientEvents();
  rows.unshift({
    id: `evt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
    coachId: coachId ?? null,
    ...evt,
  });
  await appStore.setClientEvents(rows);
}

// Note: Database events are now handled automatically by database triggers
// The addClientEventToDatabase function has been removed since nutrition events
// are now created via database triggers, consistent with workout program events
